<template>
    <div ref="map" class="w-full h-full" />
</template>

<style>
.gm-style iframe + div {
    border: none !important;
}
</style>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import Silver from '~/assets/google-map-silver.js'
import Dark from '~/assets/google-map-dark.js'

export default {
    props: {
        area: {
            type: Number,
        },
        areas: {
            type: Array,
            default: [],
        },
        subscription: {
            type: Object,
            default: null,
        },
        setAreaColor: { type: Function }
    },

    data() {
        return {
            google: null,
            map: null,
            polygons: [],
            areaKM: 0,
            lArea: this.area,
        }
    },

    mounted() {
        if (this.map != null) {
            this.clearMap()
        }

        let loader = new Loader({
            apiKey: 'AIzaSyAaQIYvddJQjeKaojwsollr-E4BiKJfyB0',
            libraries: ['geometry'],
        })

        loader.load().then((google) => {
            this.google = google
            this.initializeMap()
        })
    },

    beforeUnmount() {
        this.clearMap()
    },

    methods: {
        initializeMap() {
            this.google.maps.Polygon.prototype.getBounds = toRaw(function () {
                var bounds = new google.maps.LatLngBounds()
                var paths = this.getPaths()
                var path
                for (var i = 0; i < paths.getLength(); i++) {
                    path = paths.getAt(i)
                    for (var ii = 0; ii < path.getLength(); ii++) {
                        bounds.extend(path.getAt(ii))
                    }
                }
                return bounds
            })

            this.map = new this.google.maps.Map(this.$refs.map, {
                center: { lat: 0, lng: 0 },
                zoom: 4,
                styles: Silver,
                // styles: Dark,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
            })

            setTimeout(() => {
                if (this.subscription !== null) {
                    this.drawSubscription()
                } else {
                    this.drawAreasOnMap()
                }
            }, 500)
        },

        drawSubscription() {
            this.clearMap()

            let p = new this.google.maps.Polygon({
                paths: this.subscription.location_area.lat_lng,
                strokeColor: '#008F6B',
                strokeOpacity: 0.4,
                strokeWeight: 2,
                fillColor: '#008F6B',
                fillOpacity: 0.175,
            })

            this.polygons.push(p)
            p.setMap(this.map)
            this.map.fitBounds(p.getBounds())
        },

        goToPoint(location) {
            console.log('goToPoint', location)
            this.map.setCenter({ lat: location.latitude, lng: location.longitude })
            this.map.setZoom(15)
        },

        leavePoint() {
            let p = this.polygons[0]
            p.setMap(this.map)
            this.map.fitBounds(p.getBounds())
        },

        drawAreasOnMap() {
            if (this.areas == null || this.areas.length == 0) {
                return
            }

            for (let i = 0; i < this.areas.length; i++) {
                if (this.google == null) {
                    break
                }

                if (this.area == this.areas[i].id) {
                    // continue
                }

                let areaColor = {};
                if (this.setAreaColor != null) {
                    areaColor = this.setAreaColor(this.areas[i])
                }

                let p = toRaw(
                    new this.google.maps.Polygon({
                        paths: this.areas[i].lat_lng,
                        strokeColor: this.areas[i].available ? '#008F6B' : '#DC583C',
                        strokeOpacity: 0.4,
                        strokeWeight: 2,
                        fillColor: this.areas[i].available ? '#008F6B' : '#DC583C',
                        fillOpacity: 0.175,
                        ...areaColor
                    }),
                )

                p.areaId = this.areas[i].id

                this.polygons.push(p)
                // console.log(p)
                p.addListener('click', () => {
                    this.$emit('setArea', this.areas[i].id)
                    this.setActiveArea(this.areas[i])
                })
                p.setMap(this.map)
            }

            this.setActiveArea(this.areas.find((a) => a.id == this.area))
        },

        setActiveArea(area) {
            console.log('setActiveArea', area);

            if (area == null || area == undefined) {
                return;
            }

            for (let i = 0; i < this.polygons.length; i++) {
                let p = toRaw(this.polygons[i])
                if (p.areaId == area.id) {
                    p.setOptions({
                        strokeOpacity: 0.8,
                        fillOpacity: 0.35,
                    })

                    this.polygons[i] = p

                    this.map.fitBounds(p.getBounds())
                    try {
                        this.map.panTo(p.getBounds())
                    } catch (error) {}
                } else {
                    p.setOptions({
                        strokeOpacity: 0.4,
                        fillOpacity: 0.175,
                    })

                    p.setMap(this.map)
                }
            }
        },

        clearMap(callback = null) {
            while (this.polygons.length > 0) {
                try {
                    this.polygons[0].strokeOpacity = 0
                    this.polygons[0].fillOpacity = 0
                    this.polygons[0].setMap(this.map)
                    this.polygons[0].setMap(null)
                    this.polygons.splice(0, 1)
                } catch (error) {
                    break
                }
            }

            this.polygons = null
            this.polygons = []

            if (callback) {
                setTimeout(() => {
                    return callback()
                }, 500)
            }
        },

        redrawMap() {
            // console.log('redrawMap', this.polygons.length)
            this.clearMap(() => {
            	if (this.subscription !== null) {
            		this.drawSubscription();
            	} else {
            		this.drawAreasOnMap()
            	}
            })
        },
    },

    watch: {
    	subscription() {
    		this.redrawMap();
    	}
    }
}
</script>
